import { OptionsContext } from "@/provider/options-provider";
import { useContext, useState } from "react";
import Autocomplete from "./ui/autocomplete";
import { ComboBoxItemType } from "./ui/combobox";
import { FormField, FormItem, FormMessage } from "./ui/form";

export function TickerFormField({
  form,
  direction = "down",
  classname = "w-40",
  setTicker,
}: {
  form: any;
  direction?: "up" | "down";
  classname?: string;
  setTicker?: (ticker: string) => void;
}) {
  const { setSearchOptions, searchOptions } = useContext(OptionsContext);
  const [companies, setCompanies] = useState<ComboBoxItemType[]>([]);

  const fetchCompanies = async (s: string) => {
    if (s === "") {
      setCompanies([]);
      return;
    }
    const res = await fetch(`/list/company?s=${s}&source=FT`);
    const data = await res.json();
    setCompanies(data);
  };

  const onSelect = (value: string | undefined) => {
    if (value === "") {
      setSearchOptions({ ...searchOptions, ticker: "" });
      form.setValue("ticker", "");
    }
    setSearchOptions({ ...searchOptions, ticker: value ?? "" });
    form.setValue("ticker", value);
    setTicker?.(value ?? "");
  };

  return (
    <FormField
      control={form.control}
      name="ticker"
      render={({ field }) => (
        <FormItem>
          <Autocomplete
            className={classname}
            items={companies}
            onSelect={onSelect}
            onSearchChange={fetchCompanies}
            searchPlaceholder="Ticker..."
            value={searchOptions.ticker}
            selectItemMsg="Select a ticker..."
            noResultsMsg="searching..."
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
